var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_81049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11914 19.3486C4.11914 17.4921 4.85664 15.7116 6.16939 14.3989C7.48215 13.0861 9.26263 12.3486 11.1191 12.3486C12.9757 12.3486 14.7561 13.0861 16.0689 14.3989C17.3816 15.7116 18.1191 17.4921 18.1191 19.3486H16.3691C16.3691 17.9562 15.816 16.6209 14.8315 15.6363C13.8469 14.6518 12.5115 14.0986 11.1191 14.0986C9.72675 14.0986 8.3914 14.6518 7.40683 15.6363C6.42226 16.6209 5.86914 17.9562 5.86914 19.3486H4.11914ZM11.1191 11.4736C8.21852 11.4736 5.86914 9.12426 5.86914 6.22363C5.86914 3.32301 8.21852 0.973633 11.1191 0.973633C14.0198 0.973633 16.3691 3.32301 16.3691 6.22363C16.3691 9.12426 14.0198 11.4736 11.1191 11.4736ZM11.1191 9.72363C13.0529 9.72363 14.6191 8.15738 14.6191 6.22363C14.6191 4.28988 13.0529 2.72363 11.1191 2.72363C9.18539 2.72363 7.61914 4.28988 7.61914 6.22363C7.61914 8.15738 9.18539 9.72363 11.1191 9.72363Z",
    fill: "#525252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_81049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.619141 0.0986328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2c0a592b12d986c55c22d55bf47cf665.svg";
export { ForwardRef as ReactComponent };